import { createFileRoute, redirect } from '@tanstack/react-router'
import { FeedbackPage } from '@/pages/Feedback/FeedbackPage'
import { useAuthStore } from '@/store/authStore'
import { canAccessRoute } from '@/lib/roles'

export const Route = createFileRoute('/_authenticated/feedback')({
  component: FeedbackPage,
  beforeLoad: () => {
    const role = useAuthStore.getState().user?.role
    if (!canAccessRoute(role, '/feedback')) {
      throw redirect({ to: '/' })
    }
  },
})
